import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { RestService } from "@stdoutsrl/design-kit";
import { LoaderService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";

@Component({
  selector: "app-example-monouse-component",
  template: `
    <std-modal
      *transloco="let t"
      cardClass="!max-w-[90vw] min-w-[50vw]"
      headerClass="bg-primary"
      [show]="true"
      [closeOnOutside]="false"
      (close)="fatherContaierRef.showProducts = true;autoDestory()"
    >
      <div class="text-tertiary text-large" header>
        {{ t("createProductFromSuggestion") }}
      </div>
      <div content class="max-h-[70vh] overflow-y-scroll custom-scrollbar">
        <div class="mt-4 grid gap-4 min-h-[50vh] p-4">
          <!-- <std-select
            customLabel="label-input"
            customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
            bindValue="id"
            bindLabel="name"
            [data]="suggestionList"
            (onChangeValue)="selectedSuggestion = $event"
            [label]="'Seleziona suggerimento'"
            labelPosition="top"
            [placeholder]="'Seleziona suggerimento'"
          ></std-select> -->
          <std-table
            [data]="suggestionList"
            class="hide-bar-all  fix-table"
            tableContainerClass="bg-secondary "
            headerClass=" bg-primary focus:bg-primary hover:bg-primary"
          >
            <span stdoutTableColumn width="110" [label]="'Immagine'">
              <ng-template #dataTableCell let-item="item">
                <div class="flex items-end gap-5">
                  @if(item.image){<img
                    class="max-h-[50px] mx-auto"
                    [src]="endPointBackend + '/' + item.image"
                  />
                  }
                </div>
              </ng-template>
            </span>
            <span stdoutTableColumn label="Nome" property="name"></span>
            <span
              stdoutTableColumn
              label="Descrizione"
              property="description"
            ></span>
            <span stdoutTableColumn label="Durata" property="duration"></span>
            <span stdoutTableColumn width="110" [label]="t('actions')">
              <ng-template #dataTableCell let-item="item">
                <div class="flex items-end gap-5">
                  <std-button
                    (click)="useSuggested(item)"
                    size="xs"
                    type="primary"
                    buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary text-medium !h-auto"
                  >
                    <svg
                      class="size-[14px] fill-tertiary"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                      />
                    </svg>
                  </std-button>
                </div>
              </ng-template>
            </span>
          </std-table>
        </div>
        <div class="mt-6 flex gap-4 place-content-between">
          <std-button
            buttonClass="bg-primary focus:bg-primary hover:bg-primary"
            (click)="autoDestory()"
            class="w-[200px]"
            >{{ t("modal.cancel") }}</std-button
          >
        </div>
      </div>
    </std-modal>
  `,
  styles: [],
  standalone: false,
})
export class CompanyProductSuggestionCompleteProfileComponent implements OnInit {
  @Input() fatherElement = {};
  @Input() fatherContaierRef: any;
  suggestionList: any[] = [];
  endPointBackend = api.baseUrl;

  constructor(
    private host: ElementRef<HTMLElement>,
    private rest: RestService,
    private loader: LoaderService
  ) { }

  ngOnInit(): void {
    this.loader.on();
    this.rest.get("/item-suggested").subscribe({
      next: (value: any) => {
        this.suggestionList = value;
        this.loader.off(true);
      },
      error: (error) => {
        this.loader.off(true);
      },
    });
  }

  useSuggested(item: any) {
    this.fatherContaierRef.product = item;
    this.fatherContaierRef.productImageUrl = this.endPointBackend + '/'+ item.image
    this.fatherContaierRef.useSuggested(item)
    this.autoDestory();


  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
